<template>
    <div>
        <HeroBanner v-if="payload" v-bind="payload" :promoLink="config.promoLink" :productMetadata="config.productMetadata" />
    </div>
</template>

<script>
import HeroBanner from './index.vue'
export default {
    name: 'HeroBannerPreLoad',
    components: {
        HeroBanner,
    },
    props: {
        config: {
            type: Object,
            required: true,
        }
    },
    computed: {
        payload() {
            return this.config.payload
        }
    }
}
</script>
